<template>
  <div class="page-container">
    <div class="filter-container">
      <span class="transTime">{{ $t('merchantAccount.transaction_date') }}:</span>
      <el-date-picker
        v-model="search.times"
        class="mb-10 picker"
        size="small"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="~"
        :picker-options="pickerOptions"
        :start-placeholder="$t('components.start_date')"
        :end-placeholder="$t('components.end_date')"
      />
      <!-- <el-input v-model="search.app_name" size="small" type="text" :placeholder="$t('customerService.app_name')" class="search-frame mb-10" clearable /> -->
      <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter()">{{ $t('components.search') }}</el-button>
      <!-- 明细excel下载 -->
      <el-button v-trans-download class="mb-10 download-btn" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
    </div>
    <div class="monthly-summary">  {{ $t('data.total_transaction_details') }}  </div>
    <div class="total">
      <!-- <el-col :span="24" class="monthly-summary">{{ $t('data.monthly_summary') }}</el-col> -->
      <div class="total-item">
        <div class="total-title">{{ $t('data.collection_amount') }}</div>
        <div class="total-num">{{ dateBetweenTransSum.total_payment_amount | toDivideWithDot }}</div>
      </div>
      <div class="line" />
      <div class="total-item">
        <div class="total-title">{{ $t('data.collection_number') }}</div>
        <div class="total-num">{{ dateBetweenTransSum.total_payment_count || 0 }}</div>
      </div>
      <div class="line" />
      <div class="total-item">
        <div class="total-title">{{ $t('data.collection_fee') }}</div>
        <div class="total-num">{{ dateBetweenTransSum.total_payment_fee_split| toDivideWithDot }}</div>
      </div>
      <!-- <div class="line" />
      <div class="total-item">
        <div class="total-title">{{ $t('data.loan_amount') }}</div>
        <div class="total-num">{{ dateBetweenTransSum.total_payout_amount | toDivideWithDot }}</div>
      </div>
      <div class="line" />
      <div class="total-item">
        <div class="total-title">{{ $t('data.loan_number') }}</div>
        <div class="total-num">{{ dateBetweenTransSum.total_payout_count || 0 }}</div>
      </div>
      <div class="line" />
      <div class="total-item">
        <div class="total-title">{{ $t('data.loan_fee') }}</div>
        <div class="total-num">{{ dateBetweenTransSum.total_payout_fee_split| toDivideWithDot }}</div>
      </div> -->
      <!--      <div class="line" />-->
      <!--      <div class="total-item">-->
      <!--        <div class="total-title">{{ $t('data.refund_amount') }}</div>-->
      <!--        <div class="total-num">{{ dateBetweenTransSum.paymentRefundAmount | toDivideWithDot }}</div>-->
      <!--      </div>-->
      <!--      <div class="line" />-->
      <!--      <div class="total-item">-->
      <!--        <div class="total-title">{{ $t('data.refund_number') }}</div>-->
      <!--        <div class="total-num">{{ dateBetweenTransSum.paymentRefundCount || 0 }}</div>-->
      <!--      </div>-->
      <!--      <div class="line" />-->
      <!--      <div class="total-item">-->
      <!--        <div class="total-title">{{ $t('data.refunded_transaction_fee') }}</div>-->
      <!--        <div class="total-num">{{ dateBetweenTransSum.paymentRefundFee + dateBetweenTransSum.paymentRefundFeeSplit | toDivideWithDot }}</div>-->
      <!--      </div>-->
    </div>
    <div v-if="$store.getters.isPii" class="tips"><span><svg-icon icon-class="icon-font-warning" style="color: #3855F1;" /></span>{{ $t('tips.current_time_zone') }}</div>
    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('merchantAccount.transaction_date')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.statistic_date ? scope.row.statistic_date.split('00:00:00')[0] : scope.row.statistic_date }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.collection_amount')" prop="payment_amount" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.collection_number')" prop="payment_count" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_count }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.collection_fee')" prop="payment_fee_split" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('data.loan_amount')" prop="payout_amount" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payout_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.loan_number')" prop="payout_count" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payout_count }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.loan_fee')" prop="payout_fee_split" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payout_fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column> -->

        <!--        <el-table-column :label="$t('data.refund_amount')" prop="payout_amount" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ scope.row.payment_refund_amount | toDivideWithDot }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <!--        <el-table-column :label="$t('data.refund_number')" prop="payout_count" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ scope.row.payment_refund_count }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <!--        <el-table-column :label="$t('data.refunded_transaction_fee')" prop="payout_fee_split" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ scope.row.payment_refund_fee + scope.row.payment_refund_fee_split | toDivideWithDot }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <!--
        <el-table-column :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.app_name">{{ scope.row.app_name }}</span>
            <span v-if="!scope.row.app_name"> -- </span>
          </template>
        </el-table-column> -->

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
  </div>
</template>

<script>

import { getStatisticList } from '@/api/service-provider-tools/service-provider-tools'

import { filterEmptyAttr, exportXlsxFitWidth } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        times: [appointDate(-3), appointDate(-1)],
        app_name: ''
      },
      tableData: [],
      totalData: {},
      pageTotal: [],
      dateBetweenTransSum: {},
      total_amount: 0,
      total_fee: 0,
      total_count: 0,
      listLoading: false,
      isClassify: '0',
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    disabledDate(time) {
      return time.getTime() > (Date.now() - 60 * 60 * 24 * 1000)
    },
    getTransSumInfo(params) {
      this.listLoading = true
      getStatisticList(params).then(res => {
        const data = res.data || {}
        const { total = 0, list } = data
        this.dateBetweenTransSum = data
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list || []
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { times = [], app_name } = this.search
      let params = {
        start_time: times && times[0],
        end_time: times && times[1],
        app_name: app_name,
        // isClassify: this.isClassify,
        ...otherParams,
        auth_merchant_no: this.$route.params.merchant_no
      }
      params = filterEmptyAttr(params)
      return params
    },

    getSummaries(params) {
      const { columns, data } = params
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total'
          this.pageTotal[index] = 'Total'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        const needTotalCol = ['payment_amount', 'payment_count', 'payment_fee_split', 'payout_amount', 'payout_count', 'payout_fee_split']
        const notNeedToDivide = ['payment_count', 'payout_count']
        if (!needTotalCol.includes(column.property)) {
          sums[index] = '-'
          this.pageTotal[index] = '-'
          return
        } else {
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            const toDivideWithDot = this.$options.filters['toDivideWithDot']
            if (!notNeedToDivide.includes(column.property)) {
              sums[index] = toDivideWithDot(sums[index])
            }

            // 用于下载
            this.pageTotal[index] = sums[index]
          } else {
            sums[index] = 'N/A'
            this.pageTotal[index] = 'N/A'
          }
          return
        }
      })

      return sums
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      if (!params.start_time) {
        this.$message.warning('Transaction time is required!')
        return
      }
      this.getTransSumInfo(params)
    },
    onClickDowmloadBtn() {
      const params = this.getParams()
      if (!params) {
        return
      }
      params.page = 0
      getStatisticList(params).then(res => {
        const data = res.data.list || []
        this.handleXlsxData(data).then((downloadData) => {
          exportXlsxFitWidth(downloadData, 'Transaction_Summary')
        })
      })
    },
    // displayChange(){
    //   this.handleFilter()
    // },
    handleXlsxData(data = []) {
      const rows = [[
        this.$t('components.date'),
        this.$t('data.collection_amount'),
        this.$t('data.collection_number'),
        this.$t('data.collection_fee'),
        // this.$t('data.loan_amount'),
        // this.$t('data.loan_number'),
        // this.$t('data.loan_fee')
        // this.$t('merchant.app_name')
      ]]

      const toDivideWithDot = this.$options.filters['toDivideWithDot']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.statistic_date ? tr.statistic_date.split('00:00:00')[0] : tr.statistic_date,
            toDivideWithDot(tr.payment_amount),
            tr.payment_count,
            toDivideWithDot(tr.payment_fee_split),
            // toDivideWithDot(tr.payout_amount),
            // tr.payout_count,
            // toDivideWithDot(tr.payout_fee_split)
            // tr.app_name ? tr.app_name : '--'
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>
<style scoped>
/* .tableContainer .el-table /deep/.el-table__footer-wrapper td{
  border-top: 1px solid #D5D8DE;
}
.tableContainer .el-table /deep/.el-table__footer-wrapper tr td{
  border-right: 1px solid #D5D8DE;
}
.tableContainer .el-table /deep/.el-table__footer-wrapper tr .el-table_1_column_7{
    border-right: none;
}
.tableContainer .el-table /deep/.el-table__footer-wrapper td .cell{
  font-weight: 700;  font-family: 'Inter-Bold';
  font-size: 17px;
} */
</style>

<style lang="scss" scoped>

.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.page-container{
   margin: 40px 57px 50px 32px;
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .monthly-summary{
    font-weight: 500;  font-family: 'Inter-Medium';
    font-size: 16px;
    color: #1D3A71;
  }
  .filter-container{
    margin-top: 20px;
    // text-align: right;
    margin-bottom: 20px;
  }
  .search-frame {
    width: 160px;
    margin-right: 10px;
  }

  .search-btn {
    margin-right: 10px;
  }
  .classify-switch{
    margin: 0px;
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
   }
  .download-btn{
    margin: 0;
  }
  .picker{
    margin-right: 10px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .total{
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    margin-right: 40px;
    // .total-item{
    //   position: relative;
    // }
    .line{
      display: inline-block;
      content:'';
      height: 60px;
      width: 1px;
      background: #D3D7DF;
    }
    &-title{
      font-size: 14px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 16px;
      padding-bottom: 32px;
      font-size: 18px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #3855F1;
    }
  }
  .tips{
    border-radius: 4px;
    border: 1px solid #D3D7DF;
    padding: 10px 12px;
    margin-bottom: 32px;
    color: #7A869E;
    width: max-content;
    font-size: 12px;
    span{
      padding-right: 11px;
    }
  }
}
.total-container{
  position: relative;
  top: 40px;
  margin-top: 50px;
  font-size: 12px;
  line-height: 17px;
  color: #588efb;
  span{
    border: 1px solid #588efb;
    border-radius: 5px;
    display: inline-block;
    padding: 10px;
    margin-left: 10px;
    margin-bottom: 20px;
  }
}

</style>
